import { base64 } from '@hexagon/base64';
import { either } from 'fp-ts';
import { flow } from 'fp-ts/function';
import * as iots from './iots.js';
import * as string from './string.js';
const removePadding = string.replaceAll('=', '');
/**
 * Branded type for Base64 values. Padding is ignored.
 */
export const Base64 = iots.brand(iots.string, (s) => base64.validate(removePadding(s)), 'Base64');
/**
 * Branded type for Base64URL values. Padding is ignored.
 */
export const Base64Url = iots.brand(iots.string, (s) => base64.validate(removePadding(s), true), 'Base64Url');
// -------------------------------------------------------------------------------------------------
/**
 * Codec for encoding/decoding array buffers as Base64 strings.
 */
export const Uint8ArrayFromBase64 = new iots.Type('Uint8ArrayFromBase64', (u) => u instanceof Uint8Array, flow(Base64.validate, either.map((s) => Buffer.from(s, 'base64'))), (buffer) => iots.brandFromLiteral(Buffer.from(buffer).toString('base64')));
/**
 * Codec for encoding/decoding array buffers as Base64URL strings.
 */
export const Uint8ArrayFromBase64Url = new iots.Type('Uint8ArrayFromBase64Url', (u) => u instanceof Uint8Array, flow(Base64Url.validate, either.map((s) => Buffer.from(s, 'base64url'))), (buffer) => iots.brandFromLiteral(Buffer.from(buffer).toString('base64url')));
// -------------------------------------------------------------------------------------------------
//# sourceMappingURL=base64.js.map